export function inBox(x1: number, y1: number, x2: number, y2:number, x3: number, y3:number) {
    const minx = Math.min(x1, x2);
    const maxx = Math.max(x1, x2);
    const miny = Math.min(y1, y2);
    const maxy = Math.max(y1, y2);
    var bound = (
        x3 <= maxx && x3 >= minx && y3 <= maxy && y3 >= miny
        //x3 < maxx && x3 > minx && y3 < maxy && y3 > miny
    )
    return bound;
}

export const rectPointsInRect = (a: DOMRect, b: DOMRect)=>{
    const p1 = inBox(a.left, a.top, a.right, a.bottom, b.left, b.top);
    const p2 = inBox(a.left, a.top, a.right, a.bottom, b.right, b.top);
    const p3 = inBox(a.left, a.top, a.right, a.bottom, b.left, b.bottom);
    const p4 = inBox(a.left, a.top, a.right, a.bottom, b.right, b.bottom);
    return p1 || p2 || p3 || p4;
}

const valueInRange = (value: number, min: number, max: number) => { 
    return (value >= min) && (value <= max); 
}

export const rectInRect = (a: DOMRect, b: DOMRect)=>{
    const xOverlap = valueInRange(a.x, b.x, b.x + b.width) || valueInRange(b.x, a.x, a.x + a.width);
    const yOverlap = valueInRange(a.y, b.y, b.y + b.height) || valueInRange(b.y, a.y, a.y + a.height);
    return xOverlap && yOverlap;
}